import { render } from "./FpContainer.vue?vue&type=template&id=947c17b4"
import script from "./FpContainer.vue?vue&type=script&lang=js"
export * from "./FpContainer.vue?vue&type=script&lang=js"

import _style_0 from "./FpContainer.vue?vue&type=style&index=0&id=947c17b4&inline&lang=css"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__